import { Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';

@Component({
  selector: 'skc-breadcrumb',
  templateUrl: './bread-crumb.component.html',
  styleUrls: ['./bread-crumb.component.less']
})
export class BreadCrumbComponent extends SkeletonSizeBase implements OnInit, OnChanges {
  @Input('skc-separator') separator: string | TemplateRef<void>;
  @Input('skc-total-links') totalLinks = 2;
  @Input('skc-width') width = '80px';
  breadsCrumbs: Array<number>;
  constructor() {
    super();
  }

  ngOnInit() {
    this.breadsCrumbs = new Array(this.totalLinks).fill({});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.totalLinks && !changes.totalLinks.firstChange) {
      this.breadsCrumbs = new Array(changes.totalLinks.currentValue).fill({});
    }
  }
}
